/**
 * Specialized JSON parser for response examples that returns a distinctive error object
 * @param value - The JSON string to parse
 * @returns Parsed object or error object with __isParseError flag
 */
export const parseResponseExampleJSON = (value: string) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return { __isParseError: true, error: e.message, value };
  }
};
